var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.visible,
        width: "800px",
        "close-on-click-modal": false,
        "append-to-body": "",
        title: _vm.$t("CargoMsg.Cargo_VGMLog"),
        "before-close": _vm.toCancel
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "section row-grid",
          staticStyle: { height: "350px", padding: "0" }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", "min-height": "345px" },
            attrs: {
              no: "logGrid",
              "config-module": "150115",
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            }
          })
        ],
        1
      ),
      _c(
        "span",
        {
          staticStyle: { padding: "10px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { no: "toCancel" }, on: { click: _vm.toCancel } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Close")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }